// project constants
// it's nice there: https://goo.gl/maps/BYrB6hb7ypyKjxN37
export const TENANTS = [
  'standard',
  'motel-one',
];
export const DEFAULT_TENANT = 'standard';
export default {
  TENANTS,
  DEFAULT_TENANT,
};
